import React from "react";
import Typography from "../Typography";

export default function Wait() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        marginTop: 100
      }}
    >
      <Typography type="body1" color="deepGrey">
        Please wait...
      </Typography>
    </div>
  );
}
